import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import FormErrorMessage from '../../../../../../../atoms/FormErrorMessage';

export enum ErrorType {
  Blank = 'blank',
  Invalid = 'invalid',
  NotSupportValue = 'not_support_value',
  TooLong = 'too_long',
}

const BlankMessage: FC = () => {
  const intl = useIntl();
  return (
    <FormErrorMessage>
      {intl.formatMessage({
        id: `purchases.errors.customer.blank`,
        defaultMessage: intl.formatMessage({
          id: 'purchases.errors.blank',
        }),
      })}
    </FormErrorMessage>
  );
};

const InvalidMessage: FC = () => {
  const intl = useIntl();
  return (
    <FormErrorMessage>
      {intl.formatMessage({
        id: `purchases.errors.customer.invalid`,
        defaultMessage: intl.formatMessage({
          id: 'purchases.errors.invalid',
        }),
      })}
    </FormErrorMessage>
  );
};

const NotSupportValueMessage: FC = () => {
  const intl = useIntl();
  return (
    <FormErrorMessage>
      {intl.formatMessage({
        id: `purchases.errors.customer.not_support_value`,
        defaultMessage: intl.formatMessage({
          id: 'purchases.errors.not_support_value',
        }),
      })}
    </FormErrorMessage>
  );
};

const TooLongMessage: FC = () => {
  const intl = useIntl();
  return (
    <FormErrorMessage>
      {intl.formatMessage({
        id: `purchases.errors.customer.too_long`,
        defaultMessage: intl.formatMessage({
          id: 'purchases.errors.too_long',
        }),
      })}
    </FormErrorMessage>
  );
};

const ERROR_COMPONENTS: {
  [error in ErrorType]: React.FC;
} = {
  [ErrorType.Blank]: BlankMessage,
  [ErrorType.Invalid]: InvalidMessage,
  [ErrorType.NotSupportValue]: NotSupportValueMessage,
  [ErrorType.TooLong]: TooLongMessage,
};

interface Props {
  errors?: ErrorType[];
}

const ErrorMessage: FC<Props> = ({ errors }) => {
  if (!errors) return null;
  if (errors.length === 0) return null;

  return (
    <>
      {errors.map((error, index) => {
        const Component = ERROR_COMPONENTS[error];
        if (!Component) return null;
        return <Component key={index} />;
      })}
    </>
  );
};

export default ErrorMessage;
